// import { Icon } from "@mui/material";
// import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useEffect, useRef, useState } from "react";
import style from "./style.module.scss";
import { useNavigate } from "react-router-dom";

import { IoIosArrowDown } from "react-icons/io";

/**
 * @param {Object} props
 * @param {React.Component} props.icon
 * @param {String} props.title
 * @param {String} props.href
 * @param {React.Component} props.children
 * @returns
 * @example
 *
 * - single item:
 * <AsideItem
 *   icon={HomeIcon}
 *   title="Dashboard"
 *   href="/pbo/dashboard"
 *   {...{ shrunk }}
 * />
 *
 * - item with collapse:
 * <AsideItem
 *   icon={WebIcon}
 *   title="Páginas"
 *   {...{ shrunk }}
 * >
 *  <AsideItem
 *    icon={SecurityIcon}
 *    title="Política de Privacidade"
 *    href="/pbo/pages/privacy"
 *    {...{ shrunk }}
 *  />
 *  <AsideItem
 *    icon={GavelIcon}
 *    title="Termos de Uso"
 *    href="/pbo/pages/terms"
 *    {...{ shrunk }}
 *  />
 * </AsideItem>
 **/
const SidebarItem = ({ icon, title, children = null, href, shrunk, onItemClick }) => {
  const navigate = useNavigate();
  //const location = useLocation();

  const ref = useRef(null);

  const [open, setOpen] = useState(false);
  const [height, setHeight] = useState(0);
  const [this_route] = useState(false);

  useEffect(() => {
    // get collapse height
    setHeight(ref?.current?.scrollHeight);
  }, []);

  // useEffect(() => {
  //   // check if this route is active to set background color
  //   if (location.pathname.includes(href) && href !== "/") {
  //     setThisRoute(true);
  //   } else {
  //     if (location.pathname === href) {
  //       setThisRoute(true);
  //     } else {
  //       setThisRoute(false);
  //     }
  //   }
  // }, [location, href]);

  const handleOpenCollapse = () => {
    setOpen(!open);
  };

  return (
    <div className={style.sidebarItemContainer}>
      <div
        className={`${style.asideItem} ${open ? style.open : ''} ${this_route ? style.active : ''}`}
        onClick={
          children
            ? handleOpenCollapse
            : () => {
                navigate(href);
                onItemClick?.();
              }
        }
      >
        <span className={style.icon}>
          {icon}
        </span>

        <span className={`${style.title} ${shrunk ? style.shrunk : ''} ${this_route ? style.bold : ''}`}>
          {title}
        </span>

        {children && (
          <IoIosArrowDown
            className={`${style.arrowIcon} ${open ? style.open : ''}`}
          />
        )}
      </div>

      {children && (
        <div
          ref={ref}
          className={`${style.childrenContainer} ${open ? style.open : style.closed}`}
          style={{ maxHeight: open ? height + 16 : 0 }}
        >
          {children}
        </div>
      )}
    </div>
  );
};

export default SidebarItem;
